<template>

    <ion-tabs @IonTabsWillChange="beforeTabChange" @IonTabsDidChange="afterTabChange">

        <!-- tabs -->
        <ion-tab tab="challenges.monthly" :routes="'ChallengesMonthly'">
            <tab-monthly></tab-monthly>
        </ion-tab>
        <ion-tab tab="challenges.quarterly" :routes="'ChallengesQuarterly'">
            <tab-quarterly></tab-quarterly>
        </ion-tab>
        <ion-tab tab="challenges.summary" :routes="'ChallengesSummary'">
            <tab-summary></tab-summary>
        </ion-tab>

        <!-- tab nav bar -->
        <ion-tab-bar slot="bottom">
            <ion-tab-button tab="challenges.monthly" :to="{ name: 'ChallengesMonthly' }">
                <svg class="tab-icon"><use xlink:href="#icon-shield"></use></svg>
                <ion-label class="tab-text">Tablica</ion-label>
            </ion-tab-button>
            <ion-tab-button tab="challenges.quarterly" :to="{ name: 'ChallengesQuarterly'}">
                <svg class="tab-icon"><use xlink:href="#icon-list-challenges"></use></svg>
                <ion-label class="tab-text">Wyzwania kwartalne</ion-label>
            </ion-tab-button>
            <ion-tab-button tab="challenges.summary" :to="{ name: 'ChallengesSummary' }">
                <svg class="tab-icon"><use xlink:href="#icon-head"></use></svg>
                <ion-label class="tab-text">Twoje osiągnięcia</ion-label>
            </ion-tab-button>
        </ion-tab-bar>

    </ion-tabs>

</template>

<script>
    import Monthly from './tabs/Monthly'
    import Quarterly from './tabs/Quarterly'
    import Summary from './tabs/Summary.vue'

    export default {
        name: 'ChallangesIndex',
        components: {
            'tab-monthly' : Monthly,
            'tab-quarterly' : Quarterly,
            'tab-summary' : Summary
        },
        methods: {
            beforeTabChange(e){
//                console.log('beforeTabChange', e)
            },
            afterTabChange(e){
//                console.log('afterTabChange', e)
            },

            // this function is called inside child components!
            getChallenges() {
                this.$store.dispatch('CHALLENGES_REQUEST');
            },
            redirectToFirstTab(routeName){
                if(routeName == 'ChallangeIndex'){
                    setTimeout(()=> {
                        this.$router.push({name: 'ChallengesMonthly'})
                    }, 10)
                }
            }
        },
        mounted(){
            this.getChallenges();
            this.redirectToFirstTab(this.$route.name);
        },
        beforeRouteUpdate (to, from, next) {
            this.redirectToFirstTab(to.name);
            next();
        }
    }

</script>